import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import AppRouter from "./AppRouter";
import { queryClient } from "./lib/queryClient";
import AuthProvider from "@/auth";
import { AccessibilityProvider } from "@/shared/contexts/AccessibilityContext";

type AppProps = { base: string };

export default function App({ base }: AppProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={base}>
        <AccessibilityProvider>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </AccessibilityProvider>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
